module.exports = __webpack_public_path__ + "img/31.e791000c.png";